import { Component } from '@angular/core';
import { CostUnion } from '../../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../../shared/components/genericBaseModelDropDown';
import { CostBaseService } from '../../services/cost-base.service';

@Component({
  selector: 'app-cost-base-dropdown',
  template: '',
  standalone: true,
})
export class CostBaseDropdownComponent extends GenericBaseModelDropDown<CostUnion> {

  constructor(
    private service: CostBaseService) {
    super(service, "CostBase");
  }

  // copyToClipboard(text: string) {
  //   this.clipboardService.copyFromContent(text);
  //   this.notificationService.success(_("common.copied-to-clipboard"));
  // }
}